import {
  addCollectionToPlaylist,
  createPlaylist,
  editPlaylist,
  fetchMyPlaylists,
  fetchPlaylist,
  fetchPlaylists,
  removePlaylist,
} from "./asyncThunk";

export const fetchPlaylistsBuilder = (builder) => {
  builder.addCase(fetchPlaylists.pending, (state) => {
    state.playlists.loading = true;
  });
  builder.addCase(fetchPlaylists.fulfilled, (state, { payload }) => {
    const { page, total, data } = payload;
    state.playlists.loading = false;
    state.playlists.data = data;
    state.playlists.page = page;
    state.playlists.total = total;
  });
  builder.addCase(fetchPlaylists.rejected, (state) => {
    state.playlists.loading = false;
    state.playlists.error = true;
  });
};

export const fetchMyPlaylistsBuilder = (builder) => {
  builder.addCase(fetchMyPlaylists.pending, (state) => {
    state.myPlaylists.loading = true;
  });
  builder.addCase(fetchMyPlaylists.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.myPlaylists.loading = false;
    state.myPlaylists.data = data;
    state.myPlaylists.isFetched = true;
  });
  builder.addCase(fetchMyPlaylists.rejected, (state) => {
    state.myPlaylists.loading = false;
    state.myPlaylists.error = true;
  });
};

export const fetchPlaylistBuilder = (builder) => {
  builder.addCase(fetchPlaylist.pending, (state) => {
    state.playlist.loading = true;
  });
  builder.addCase(fetchPlaylist.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.playlist.loading = false;
    state.playlist.data = data;
  });
  builder.addCase(fetchPlaylist.rejected, (state) => {
    state.playlist.loading = false;
    state.playlist.error = true;
  });
};

export const createPlaylistBuilder = (builder) => {
  builder.addCase(createPlaylist.pending, (state) => {
    state.pending.createPlaylist = true;
  });
  builder.addCase(createPlaylist.fulfilled, (state, { payload }) => {
    state.pending.createPlaylist = false;
    state.playlists.data = [payload, ...state.playlists.data];
    state.myPlaylists.data = [payload, ...state.myPlaylists.data];
  });
  builder.addCase(createPlaylist.rejected, (state) => {
    state.pending.createPlaylist = false;
  });
};

export const removePlaylistBuilder = (builder) => {
  builder.addCase(removePlaylist.pending, (state) => {
    state.pending.removePlaylist = true;
  });
  builder.addCase(removePlaylist.fulfilled, (state, { payload }) => {
    state.pending.removePlaylist = false;
    state.playlists.data = state.playlists.data.filter(
      (playlist) => playlist._id !== payload._id,
    );

    state.myPlaylists.data = state.myPlaylists.data.filter(
      (playlist) => playlist._id !== payload._id,
    );
  });
  builder.addCase(removePlaylist.rejected, (state) => {
    state.pending.removePlaylist = false;
  });
};

export const addCollectionToPlaylistBuilder = (builder) => {
  builder.addCase(addCollectionToPlaylist.pending, (state) => {
    state.pending.addCollectionToPlaylist = true;
  });
  builder.addCase(addCollectionToPlaylist.fulfilled, (state, { payload }) => {
    state.pending.addCollectionToPlaylist = false;
  });
  builder.addCase(addCollectionToPlaylist.rejected, (state) => {
    state.pending.addCollectionToPlaylist = false;
  });
};

export const editPlaylistBuilder = (builder) => {
  builder.addCase(editPlaylist.pending, (state) => {
    state.pending.editPlaylist = true;
  });
  builder.addCase(editPlaylist.fulfilled, (state, { payload }) => {
    state.pending.editPlaylist = false;
    state.playlist.data = payload;
  });
  builder.addCase(editPlaylist.rejected, (state) => {
    state.pending.editPlaylist = false;
  });
};
